<template>
  <section class="mastercard-banner container">
    <figure class="mastercard-img-wrapper">
      <img :src="masterCardImg" alt="mastercard" />
    </figure>
    <div class="mastercard-content">
      <p class="header-two">
        Apply for the REI Co-op MasterCard and you could be instantly approved
        and earn a $100 REI gift card
      </p>
      <p>
        Upon approval, you'll also get 5% back on this purchase. Plus, you'll
        get 1% back everywhere else you use your card.
        <a href="#">Learn now & apply now</a>
      </p>
    </div>
  </section>
</template>

<script>
import MasterCard from "../assets/mastercard.png";

export default {
  computed: {
    masterCardImg() {
      return MasterCard;
    },
  },
};
</script>

<style lang="scss">
//
// Todo: scoped will break styles when using with scss imports here
// Just used basic css here. Can also use scss, or css frameworks but not for this project.
//
@import "../styles/globals/globals.scss";

//
// Start off with desktop design first since mock is for that
// Depends if the team prioritizes for mobile-first or desktop-first
//

.mastercard-banner.container {
  margin-top: -16px;
  padding-top: 0;
  border-top: 1px solid $light-grey;
  border-bottom: 1px solid $light-grey;
  padding-top: 32px;
  padding-bottom: 32px;

  @media screen {
    @media (min-width: $breakpoint-sm) {
      margin-top: -64px;
      padding-top: 64px;
      padding-bottom: 64px;
    }
  }
}

.mastercard-banner {
  // desktop styling
  display: flex;
  flex-direction: column;

  @media (min-width: $breakpoint-sm) {
    flex-direction: row;
  }
}

.mastercard-img-wrapper {
  max-width: 380px;
  margin-right: 50px;

  @media screen {
    @media (min-width: $breakpoint-sm) {
      width: 100%;
    }
  }
}

.mastercard-img-wrapper img {
  max-width: 100%;
}

.mastercard-content .header-two {
  font-size: $font-size-3xl;
  line-height: 1.2;
}
</style>
